<template>
  <div>
    <div class="pa-sm">
      <!-- Filter Header -->
      <div class="columns is-mobile is-marginless">
        <div class="column is-narrow">
          <b-icon :icon="filter.icon"></b-icon>
        </div>
        <div class="column">
          <p class="has-text-weight-bold mb-sm">{{ filter.label }}</p>
        </div>
        <div class="column is-narrow">
          <b-button type="is-primary" size="is-small" outlined @click="expanded = !expanded" v-text="(expanded) ? 'Collapse' : 'Expand'"></b-button>
        </div>
      </div>
      <!-- Selected Options (Tags) -->
      <div v-if="!expanded" class="pb-md px-md">
        <b-field grouped group-multiline>
          <!-- No filters enabled -->
          <div v-if="selected.length === 0">
            <p class="has-text-grey-light mb-sm is-size-7">No options applied for this filter (click 'Expand' to select).</p>
          </div>
          <div v-else v-for="option in selected" class="control" :key="option.name">
            <b-tag type="is-primary" attached closable @close="remove(option)">{{ option.value }}</b-tag>
          </div>
        </b-field>
      </div>
      <!-- Available -->
      <div v-else class="pb-md px-md">
        <!-- Autocomplete Input -->
        <b-autocomplete
           field="value"
           v-model="tagName"
           :placeholder="placeholder"
           :loading="loading"
           :data="results"
           :clear-on-select="true"
           @typing="search"
           @select="add"
           expanded>
           <template slot-scope="props">
             <div class="media">
               <div class="media-left">
                 <img width="32" src="">
               </div>
               <div class="media-content">
                 <p class="is-size-7">
                   <span class="has-text-grey">ID: {{ props.option.id }} {{ props.option.value }}</span>
                 </p>
               </div>
             </div>
           </template>
        </b-autocomplete>
        <!-- Selected tag Input -->
        <div v-if="selected.length > 0" class="mt-md">
          <div v-for=" tag in selected" :key="tag.id" class="field">
            <b-checkbox v-model="selected" :native-value="tag" @input="announce">{{ tag.value }}</b-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
export default {
  components: {},
  computed: {
    ...mapGetters(['context']),
    placeholder () {
      return 'Search values...'
    }
  },
  data () {
    return {
      expanded: false,
      loading: false,
      results: [],
      selected: [],
      tagName: ''
    }
  },
  methods: {
    search: debounce(function (name) {
      if (this.tagName !== '') {
        this.queryApi()
      }
    }, 500),
    queryApi () {
      this.loading = true
      this.$http.get(`${this.endpoint}/?name_search=${this.tagName}`).then(({ data: { results } }) => {
        this.results = results.map(({ id, name }) => ({ id, value: name }))
      }).finally(() => {
        this.loading = false
      })
    },
    add (result) {
      if (result !== null) {
        if (this.$utils.find(this.selected, { value: result.value }) === undefined) {
          this.selected.push(result)
        }
      }
      this.announce()
    },
    remove (result) {
      const remaining = this.$utils.filter(this.selected, o => {
        return o.value !== result.value
      })
      this.selected = remaining
      this.announce()
    },
    announce () {
      this.$emit('input', this.selected)
    }
  },
  created () {
    if (typeof this.value !== 'undefined' && Array.isArray(this.value) && this.value.length > 0) {
      this.selected = this.value
    }
  },
  props: ['filter', 'endpoint', 'value', 'responseType', 'resourceLabel']
}
</script>
